module.exports = "<div class=\"col-sm-10 col-md-10 main\">\n\t\t\t\t<h1 class=\"page-header\">Submitted FX Order Event Log</h1>\n\t\t\t\t<div id='jqxWidget'\tstyle=\"font-size: 13px; font-family: Verdana; float: left; width: 100%; height: 50%;\">\n\t\t\t\t\t<div id=\"jqxGrid\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sub-fx-orders-h/sub-fx-orders-h.component.html
// module id = ../../../../../src/app/pages/history/sub-fx-orders-h/sub-fx-orders-h.component.html
// module chunks = main